// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Button_spinner__bb_Ba","btntext":"Button_btntext__wZE9x","btntext-icon":"Button_btntext-icon__qtlhY"};